export interface SsoErrorInfo {
  title: string;
  message: string;
  detail?: string;
}

const cleanParam = (value: string | null): string => {
  return (value || "").replace(/\+/g, " ").trim();
};

export const getSsoErrorInfo = (
  params: URLSearchParams,
): SsoErrorInfo | null => {
  const error = cleanParam(params.get("error"));
  const errorDescription = cleanParam(params.get("error_description"));
  const errorCode = cleanParam(params.get("code"));
  const detail = errorDescription || error;

  if (!error && !errorDescription && !errorCode) return null;

  const normalized = detail.toLowerCase();

  if (
    normalized.includes("not authorized") ||
    normalized.includes("unauthorized")
  ) {
    return {
      title: "Microsoft SSO access denied",
      message:
        "Your Microsoft account signed in successfully, but this app has not authorized your account for SSO access.",
      detail,
    };
  }

  if (normalized.includes("tenant") || normalized.includes("organization")) {
    return {
      title: "Microsoft tenant mismatch",
      message:
        "This Microsoft account does not belong to the organization configured for this app.",
      detail,
    };
  }

  if (normalized.includes("expired") || normalized.includes("timeout")) {
    return {
      title: "Microsoft sign-in expired",
      message:
        "The Microsoft sign-in session expired before the app could complete authentication. Please try again.",
      detail,
    };
  }

  return {
    title: "Microsoft SSO failed",
    message:
      "The app could not complete Microsoft SSO. Please try again or contact an administrator with the details below.",
    detail: detail || errorCode,
  };
};

export const formatSsoErrorMessage = (errorInfo: SsoErrorInfo): string => {
  return errorInfo.detail
    ? `${errorInfo.title}: ${errorInfo.message} Details: ${errorInfo.detail}`
    : `${errorInfo.title}: ${errorInfo.message}`;
};
